<template>
  <div style="display:flex;">
    <el-main v-show="isshow" class="box-main1 " style="position: fixed;left: 0;top:0;background: rgba(0,0,0,0.8);width: 100%;height: 360%;z-index: 10;">
      <el-card class="box-card" style="position: relative" >

        <div style="height: 120px" >
          <img @click="close" style="width: 30px;height: 30px;position: absolute; right: 6px;top: 6px" class="logos" src="../assets/images/close.png" alt="关闭">
          <div style="text-align: center" >
            <img class="logos" src="../assets/images/logo.png" alt="13短网址">
          </div>

          <div style="text-align: center;color: #52a43a;padding: 6px 4px;background-color: #e4ebd9;font-size: 14px;font-weight: 540; ">登陆后便于管理您的短网址，查看访问量和修改原地址</div>
        </div>
        <el-tabs  v-model="activeName" @tab-click="selectIndex">
          <el-tab-pane  name="1" label="验证码登入">
            <el-form :model="codeForm" :rules="rules" ref="codeForm">
              <el-form-item prop="phone">
                <el-input placeholder="请输入手机号" v-model="codeForm.phone" clearable prefix-icon="el-icon-mobile-phone" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input placeholder="请输入验证码" v-model="codeForm.code" clearable prefix-icon="el-icon-message" maxlength="6" class="vcode" style="width: 200px;margin-right: 20px"></el-input>
                <el-button type="primary" :disabled="disabled" @click="sendCode" class="sendBtn">{{btnTxt}}</el-button>
              </el-form-item>
              <el-form-item prop="agreement">
                <el-checkbox v-model="codeForm.agreement">阅读并接受</el-checkbox>
                <span class="agreement" @click="agreement">《用户服务协议》</span>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('codeForm')" :loading="btnLoading" class="login_btn">{{loginBtnTxt}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="2" label="密码登入">
            <el-form :model="passForm" :rules="rules" ref="passForm">
              <el-form-item prop="phone">
                <el-input placeholder="请输入手机号" v-model="passForm.phone" clearable prefix-icon="el-icon-user"></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input placeholder="请输入密码" v-model="passForm.pass" clearable show-password prefix-icon="el-icon-lock"></el-input>
              </el-form-item>
              <el-form-item prop="agreement">
                <el-checkbox v-model="passForm.agreement">阅读并接受</el-checkbox>
                <span class="agreement" @click="agreement">《用户服务协议》</span>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('passForm')" :loading="btnLoading" class="login_btn">{{loginBtnTxt}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="3" label="微信登入">

            <div class="qrCode">
              <div class="code-div" ref="qrCodeDiv"></div>
              <div class="image-slot" v-show="expireSeconds===0"><i class="el-icon-refresh-right"></i></div>
            </div>
            <div class="countdown" style="height: 60px;padding-top: 10px">
              微信扫描二维码完成登录/注册<br><br>
              二维码有效期：<span style="color: #ab1e1e">{{expireTxt}}</span></div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-main>
    <div class="bra2">
    <div class="center2" style="width: 100%;">
      <router-link to="/"><img class="logos" src="../assets/images/logo.png" alt="天天短网址" style="height: 30px;width:auto;"></router-link>


      <div :class="$route.path=='/home'?'current':''">
        <a href="https://t.me/zhuzhuxia1881" target="_blank"> 客服飞机： @zhuzhuxia1881  </a>
        <a href="https://t.me/xiaomo556677" target="_blank"> 客服飞机： @xiaomo556677 </a>
        <a href="http://wpa.qq.com/msgrd?v=3&uin=3920572477&site=qq&menu=yes" target="_blank"> 客服QQ一：3920572477  </a>
        <a href="http://wpa.qq.com/msgrd?v=3&uin=3683390325&site=qq&menu=yes" target="_blank">  客服QQ二: 3683390325 </a>

      </div>

      <div :class="$route.path=='/home'?'curren t':''"><router-link to="/home">缩短网址</router-link></div>
      <div :class="$route.path=='/home_price'?'current':''"><router-link to="/home_price"> 收费</router-link></div>
      <div :class="$route.path=='/exlcusiveDomain'?'current':''"><router-link to="/exlcusiveDomain"><em class="iconfont icon-dwzfire-fill" style="color:#eca51c;font-size:18px;"></em>专属域名</router-link></div>
      <div :class="$route.path=='/home_hm'?'current':''"><router-link to="/home_hm">活码</router-link></div>
      <div :class="$route.path=='/home_page'?'current':''"><router-link to="/home_page"> h5单页</router-link></div>
      <div :class="$route.path=='/apidoc'?'current':''"><router-link to="/apidoc">API</router-link></div>
      <div :class="$route.path=='/about'?'current':''"><router-link to="/about">关于</router-link></div>


      <div v-if="isGuest"><router-link to="/login" ><i class="iconfont iconyonghu"></i> 登录</router-link></div>
      <!--        <div v-if="isGuest"><router-link to="/recording" onclick="_czc.push(['_trackEvent', '主页按钮', '点击', '转换记录','1','dafen'])"><i class="iconfont iconjilu2"></i> 转换记录</router-link></div>-->
      <div v-else class="profile">
        <router-link to="/tabs/index">
          <span v-show="isVip"><i class="iconfont iconVIP gold"></i></span>
          <span style="padding-left: 2px">{{user_info.nickname}}</span>

        </router-link>
      </div>
    </div>
    </div>
    <agreement ref="agreement"></agreement>
    <el-dialog title="提示" :visible.sync="captchaDialog" center :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
            <span>
                <span class="captcha-lab">验证码：</span>
                <el-input class="captcha-inp" style="width: 160px" v-model="captcha" maxlength="4" clearable placeholder="请输入右边验证码"></el-input>
                <img class="captcha-img" :src="captchaUrl" alt="点我刷新" @click="refreshRanCode">
            </span>
      <span slot="footer">
                <el-button @click="captchaDialog=false">取 消</el-button>
                <el-button type="primary" @click="captchaVerification">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import agreement from "@/components/agreement";
import apiConfig from "@/api/api.config";
import QRCode from "qrcodejs2";

export default {
  name: "Header2",
  components: {
    agreement:agreement
  },
  data(){
    let phone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if (value.match(/0?(13|14|15|16|17|18|19)[0-9]{9}/) == null) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    let code = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else if (value.match(/^\d{6}$/) == null) {
        callback(new Error('请输入六位验证码'));
      } else {
        callback();
      }
    };
    let pass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 5 || value.length > 20) {
        callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };
    let agreement = (rule, value, callback) => {
      if (value){
        callback();
      } else {
        callback(new Error('请阅读并勾选用户协议'));
      }
    };
    return {
      isVip: false,
      isGuest: true,
      isshow:false,
      user_info: {},
      activeName: '1',
      time: 0,
      disabled: false,
      btnTxt: "获取验证码",
      btnLoading: false,
      loginBtnTxt: "登入",
      uniqueID: "",
      captcha: "",
      captchaUrl: "",
      captchaStr: "",
      captchaDialog: false,
      wxScene: "",
      wxInterval1: "",
      wxInterval2: "",
      wxQrCodeUrl: "",
      expireTxt: "未获取",
      expireSeconds: 0,

      codeForm: {
        phone: '',
        code: '',
        agreement: true,
      },
      passForm: {
        phone: '',
        pass: '',
        agreement: true,
      },
      rules: {
        phone: [
          { validator: phone, trigger: 'blur' }
        ],
        code: [
          { validator: code, trigger: 'blur' }
        ],
        pass: [
          { validator: pass, trigger: 'blur' }
        ],
        agreement: [
          { validator: agreement, trigger: 'blur' }
        ],
      },
    };
  },
  mounted() {console.log(this.$route.path)
    const token = this.$storeLocal.get('token');
    const user_info = this.$storeLocal.get('userInfo');
    const times = Date.parse(new Date())/1000;

    if (token !== null && token !== '' && token !== undefined) {
      if (user_info.expire_date > times){
        this.isVip = true;
      }
      this.isGuest = false;
      this.user_info = user_info;
    }
  },
  methods:{
    selectIndex() {
      const index = this.activeName;
      this.btnLoading = false;
      this.loginBtnTxt = "登入";
      if (index === '3'){
        this.getWxQrCode();
      }else {
        this.lClearInterval();
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === 'codeForm') {
            this.codeLogin();
          } else if (formName === 'passForm') {
            this.login();
          }
        }
      });
    },
    async close(){
      this.isshow=false;
    },
    async login() {
      console.log('login');
      this.btnLoading = true;
      this.loginBtnTxt = "登入中...";
      let postdata = {
        phone: this.passForm.phone,
        pass: this.passForm.pass,
        check: this.passForm.agreement,
      };
      const {ret,data} = await this.$api.passLogin(postdata);
      this.btnLoading = false;
      this.loginBtnTxt = "登入";
      if (ret === 1000){
        this.$storeLocal.set('token',data.token);
        this.$storeLocal.set('userInfo',data.user_info);
        this.$store.state.token = data.token;
       // await this.$router.push('/tabs/index');
        window.location.reload(1);
      }
    },
    async codeLogin() {
      console.log('codeLogin');
      this.btnLoading = true;
      this.loginBtnTxt = "登入中...";
      let postdata = {
        phone: this.codeForm.phone,
        code: this.codeForm.code,
        check: this.codeForm.agreement,
      };
      const {ret,data} = await this.$api.login(postdata);
      this.btnLoading = false;
      this.loginBtnTxt = "登入";
      if (ret === 1000){
        this.$storeLocal.set('token',data.token);
        this.$storeLocal.set('userInfo',data.user_info);
        this.$store.state.token = data.token;
        this.$cookies.remove('codeTime');
        window.location.reload(1);
      }
    },
    async wxLogin() {
      console.log('wxLogin');
      const scene = this.wxScene;
      if (scene === "") return;
      if (this.expireSeconds === 0) return;
      const {ret,data} = await this.$api.wxLogin({id:scene});
      if (ret === 1000){
        this.$storeLocal.set('token',data.token);
        this.$storeLocal.set('userInfo',data.user_info);
        this.$store.state.token = data.token;
        this.lClearInterval();
        //await this.$router.push('/tabs/index');
        window.location.reload(1);
      }else if (ret === 488) {
        this.lClearInterval();
        await this.$router.push('/wxMpBind/'+data.id);
      }else if (ret === 489) {
        setTimeout(this.wxLogin,1000);
      }else {
        this.lClearInterval();
      }
    },
    async getWxQrCode() {
      const scene = this.wxScene;
      const {ret,data} = await this.$api.wxQrCode({id:scene});
      if (ret === 1000){
        this.wxScene = data.scene;
        this.wxQrCodeUrl = data.url;
        this.expireSeconds = data.expireSeconds;
        this.qrCodeCountTime();
        this.bindQRCode();
        this.wxLogin();
      }
    },
    async sendCode() {

      const phone = this.codeForm.phone;
      if (phone === ""){
        this.$message.error("请输入手机号码！");
        return;
      }
      if (phone.match(/0?(13|14|15|16|17|18|19)[0-9]{9}/) == null){
        this.$message.error("请输入正确的手机号码！");
        return;
      }
      if (this.captchaStr === "") {
        this.refreshRanCode();
        this.captchaDialog = true;
        return;
      }
      const captcha = this.$cookies.get('captchaStr');
      const getData = {
        phone: phone,
        captcha: captcha,
        unique_id: this.uniqueID,
      };

      const {ret} = await this.$api.sendSms(getData);
      console.log('2222')
      if (ret === 1000){
        console.log('111')
        this.time = 60;
        this.timer();
        this.$message.success("发送成功");
      }else if (ret === 4002){
        this.refreshRanCode();
        this.captchaStr = "";
        this.captchaDialog = true;
        this.$cookies.remove('captchaStr');
      }else {
        console.log('send code error ...');
      }
    },
    async captchaVerification() {
      const vCode = this.captcha;
      const time = parseInt((new Date().getTime())/1000);
      if (vCode === ""){
        this.$message.error("请填写验证码！");
        return;
      }
      let ph = this.codeForm.phone;
      let sg = this.$common.captchaSign(ph,vCode,time);
      let getData = {
        ph: ph,
        sg: sg,
        code: vCode,
        time: time,
        unique_id: this.uniqueID,
      };
      const {ret,data} = await this.$api.captcha(getData);
      if (ret === 1000){
        this.captchaStr = data.keys;
        this.$cookies.set('captchaStr',data.keys);
        this.captchaDialog = false;
        this.sendCode();
      }else if (ret === 4005){
        this.refreshRanCode();
      }
    },
    async refreshRanCode() {
      console.log('2222')
      const baseUrl = apiConfig.baseUrl;
      const {ret,data} = await this.$api.getCode();
      if (ret === 1000){
        this.uniqueID = data.id;
        this.captchaUrl = baseUrl+data.url;
      }else {
        this.$message.error('出错了！请刷新重试');
      }
    },
    timer() {
      if(this.time > 0){
        this.time--;
        this.disabled = true;
        this.btnTxt = this.time+"s后重新获取";
      }
      const auth_timer = setInterval(()=>{
        if(this.time > 0){
          this.time--;
          this.disabled = true;
          this.$cookies.set('codeTime',this.time);
          this.btnTxt = this.time+"s后重新获取";
        }else {
          this.time = 0;
          this.btnTxt = "获取验证码";
          this.disabled = false;
          this.$cookies.remove('codeTime');
          clearInterval(auth_timer)
        }
      },1000);
    },
    bindQRCode() {
      const txt = this.wxQrCodeUrl;
      if (txt === '') return;
      this.$refs.qrCodeDiv.innerHTML = '';
      new QRCode(this.$refs.qrCodeDiv, {
        text: txt,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    agreement() {
      this.$refs.agreement.show();
    },
    qrCodeCountTime() {
      let $this = this;
      let t = $this.expireSeconds-1;
      $this.expireTxt = Math.floor(Math.floor(t%3600)/60)+"分"+Math.floor(t%60)+"秒";
      $this.wxInterval1 = setInterval(function () {
        const min = Math.floor(t%3600);
        const minute = Math.floor(min/60);//分钟
        const second = t%60 ;//秒
        $this.expireTxt = minute+"分"+second+"秒";
        if(t === 0){
          $this.lClearInterval();
          return;
        }
        t--;
      },1000);
    },
    lClearInterval() {
      if (this.expireSeconds > 0) this.expireSeconds = 0;
      if (this.wxInterval1 !== "") clearInterval(this.wxInterval1);
      if (this.wxInterval2 !== "") clearInterval(this.wxInterval2);
      this.$refs.qrCodeDiv.innerHTML = '';
    }
  }
}
</script>

<style>




  .bra2 {
    width: 100%;
    height: 30px;

  }

  .bra2 .center2 {
    width: 1200px;
    height: 30px;
    margin: 0 auto;
    line-height: 30px;
    position: relative;
    text-align: right;
    color: #333;
    font-weight:bold;
  }

  .bra2 .center2 a{color:#333;font-size: 14px;font-weight: 400}
  .bra2 .center2 .logos {
    width: 130px;
    position: absolute;
    top: 15px;
    left: 10px;
  }

  .bra2 .center2 div {
    display: inline-block;
    padding: 0 14px;
    vertical-align: top;

  }


  .bra2 .center2 .profile {
    height: 100%;
    text-align: left;
  }

  .bra2 .center2 .profile img {
    width: 40px;
    height: 40px;
    border-radius: 50px;
    margin-top: 20px;
    vertical-align: top;
  }

  .bra2 .center2 .profile span {
    display: inline-block;
    vertical-align: top;
    padding-left: 10px;
    height:30px;
    line-height: 30px;
  }

  .kk2{position: relative;}
  .kk2 div{position: absolute;top:40px;left:0px;display: none !important;z-index: 999;}
  .kk2:hover div{display: block !important;}
</style>
